import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import moment from "moment"
import CustomSpinner from "components/Common/CustomSpinner"
import UnAuthorizedPopup from "components/Common/UnAuthorized/UnAuthorizedPopup"
import { useTranslation } from "react-i18next"

function TicketClientLog({ ticketLogData, loading }) {
  const { access, authorized } = useSelector(state => ({
    access: state.Login?.userAccess,
    authorized: state.Login.authorized,
  }))

  const { t, i18n } = useTranslation()

  useEffect(() => {
    // fetchTicketLog()
  }, [])

  const formatLog = log => {
    const userFullName = `${log.user?.team?.name}`
    const assigneeFullName = `${log.assignee?.team?.name}`
    const fromUserFullName = `${log.transfer?.from?.team?.name}`
    const toUserFullName = `${log.transfer?.to?.team?.name}`

    const formattedDate = moment(log.createdAt).format("DD MMMM YYYY hh:mm A")

    switch (log.log) {
      case "create":
        return {
          title: t("log.create.title"),
          description: t("log.create.description", { userFullName }),
          date: formattedDate,
        }
      case "assign":
        return {
          title: t("log.assign.title"),
          description: t("log.assign.description", {
            userFullName,
            assigneeFullName,
          }),
          date: formattedDate,
        }
      case "transfer":
        return {
          title: t("log.transfer.title"),
          description: t("log.transfer.description", {
            userFullName,
            fromUserFullName,
            toUserFullName,
          }),
          date: formattedDate,
        }
      case "close":
        return {
          title: t("log.close.title"),
          description: t("log.close.description", { userFullName }),
          date: formattedDate,
        }
      case "priority":
        return {
          title: t("log.priority.title"),
          description: t("log.priority.description", {
            userFullName,
            priority: log.priority,
          }),
          date: formattedDate,
        }
      case "status":
        return {
          title: t("log.status.title"),
          description: t("log.status.description", {
            userFullName,
            status: log.status.endUserDisplayName,
          }),
          date: formattedDate,
        }
      case "client":
        return {
          title: t("log.client.title"),
          description: t("log.client.description", { userFullName }),
          date: formattedDate,
        }
      case "comment":
        return {
          title: t("log.comment.title"),
          description: t("log.comment.description", { userFullName }),
          date: formattedDate,
        }
      case "takeOwnership":
        return {
          title: t("log.takeOwnership.title"),
          description: t("log.takeOwnership.description", { userFullName }),
          date: formattedDate,
        }
      case "clientComment":
        return {
          title: t("log.clientComment.title"),
          description: t("log.clientComment.description"),
          date: formattedDate,
        }
      default:
        return null
    }
  }

  if (!authorized) {
    return <UnAuthorizedPopup />
  }

  return (
    <div>
      {loading ? (
        <CustomSpinner />
      ) : (
        ticketLogData.map((log, index) => {
          const formattedLog = formatLog(log)

          return (
            formattedLog && (
              <div key={index} className="mb-4">
                <div className="d-flex justify-content-between">
                  <h6
                    className="font-size-16 mb-1"
                    style={{ fontWeight: "500" }}
                  >
                    {formattedLog.title}
                  </h6>
                  <small className="font-size-12 text-muted">
                    {formattedLog.date}
                  </small>
                </div>
                <p className="font-size-14 text-muted mb-1">
                  {formattedLog.description}
                </p>
                <hr className="my-3" />
              </div>
            )
          )
        })
      )}
    </div>
  )
}

export default TicketClientLog
